

const productStyle = {
  section: {
    padding: "35px 0",
    textAlign: "center",
    // marginBottom: "4rem",
    backgroundColor: "#000",
  },
  title: {
 
    marginBottom: "1rem",
    marginTop: "30px",
    minHeight: "32px",
    textDecoration: "none",
  },
  description: {
    color: "#999",
  },
};

export default productStyle;
